import { render } from "./WriteNumberResponse.vue?vue&type=template&id=19a841dc"
import script from "./WriteNumberResponse.vue?vue&type=script&lang=js"
export * from "./WriteNumberResponse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Questionnaire/Question/WriteNumberResponse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "19a841dc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('19a841dc', __exports__)) {
    api.reload('19a841dc', __exports__)
  }
  
  module.hot.accept("./WriteNumberResponse.vue?vue&type=template&id=19a841dc", () => {
    api.rerender('19a841dc', render)
  })

}


export default __exports__